<div class="metrics">
    @for (metric of _metrics; track $index) {
        <div class="metric-container">
            <span class="metrics-label">{{ metric.label }}</span>
            <span class="metrics-value">{{ metric.value }}</span>
        </div>
    }
</div>
